import { errorHandler } from "@/services/toastHandler";

const SETTING = { section: "bonus-cashback", key: "stake-bonus-threshold" };

const stakeBonusThresholdModule = {
  namespaced: true,
  state: {
    loading: false,
    saving: false,
  },
  mutations: {
    LOADING: (s, data) => (s.loading = data),
    SAVING: (s, data) => (s.saving = data),
  },
  actions: {
    async getStakeBonusThreshold({ commit }) {
      commit("LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/settings/detail", {
          params: SETTING,
        });
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING", false);
      }
    },
    // value is a plain number, e.g. 10000
    async updateStakeBonusThreshold({ commit }, threshold) {
      commit("SAVING", true);
      try {
        const res = await this.$api.post("/v1/portal/settings/update", {
          ...SETTING,
          value: threshold,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SAVING", false);
      }
    },
  },
};

export default stakeBonusThresholdModule;
